import { sendError } from '@components/Noti';
import {
  type Files,
  type PanoCollectionItem,
  TaskAction,
  type TaskRequestItem,
} from '@types';
import { toFlag } from 'pano-utils';
import domain from '../../domain';
import { $libUploadingPano } from '../../stores/libUploading';
import PanoCollection from './PanoCollection';
import panoUpload from './panoUpload';
import { taskCreateApi } from './taskApis';

const panoTask = domain.effect(
  async ({
    files,
    albumId,
    watermarked = false,
    watermarkUrl,
  }: {
    albumId: number;
    files: Files;
    watermarked?: boolean;
    watermarkUrl: string;
  }) => {
    const taskMap = new Map<string, PanoCollectionItem>();
    const collection = new PanoCollection((item) => {
      $libUploadingPano.api.add({
        id: item.id,
        name: item.name,
      });
      taskMap.set(item.id, item);
    });
    for (let i = 0; i < files.length; i++) {
      await collection.addFile(files[i]);
    }
    collection.uncompleteCheck();
    if (!taskMap.size) return;
    const panos: TaskRequestItem[] = [...taskMap.values()].map((x) => ({
      action: TaskAction.new,
      albumId,
      exif: x.exif,
      fileId: x.id,
      gps: x.gps,
      name: x.name,
      size: x.size,
      watermarked: toFlag(watermarked),
      watermarkUrl,
    }));
    const tasks = await taskCreateApi(panos);
    for (let i = 0; i < tasks.length; i++) {
      const taskResp = tasks[i];
      const taskItem = taskMap.get(taskResp.fileId);
      if (!taskItem) return;
      $libUploadingPano.api.libId({ id: taskItem.id, libId: taskResp.panoId });
      const onProgress = (progress: string) => {
        $libUploadingPano.api.progress({ id: taskItem.id, progress });
      };
      await panoUpload({ taskResp, taskItem, onProgress });
      $libUploadingPano.api.progress({ id: taskItem.id, progress: '制作中' });
    }
  }
);

panoTask.failData.watch((e) => {
  sendError(e.message);
});

export default panoTask;
